import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { GuardedPageRoute } from '../routeGuards';
import {
  ApproveHistoryPage,
  ApproveRequestPage,
  CreateAccountPage,
  EditAccountPage,
  ManageAccountsPage,
  UserHistoryPage,
} from '../lazyPages';

export const StaffManageUserRoutes = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('STAFF_SIDEBAR.MANAGE_ACCOUNTS.TITLE')}>
            <ManageAccountsPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="create"
        element={
          <GuardedPageRoute pageName={t('CREATE_USER')} action="create">
            <CreateAccountPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="edit/:id"
        element={
          <GuardedPageRoute pageName={t('EDIT_USER')} action="update">
            <EditAccountPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="approve-request"
        element={
          <GuardedPageRoute
            pageName={t('STAFF_SIDEBAR.MANAGE_ACCOUNTS.APPROVE_REQUEST')}
          >
            <ApproveRequestPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="approve-history"
        element={
          <GuardedPageRoute
            pageName={t('STAFF_SIDEBAR.MANAGE_ACCOUNTS.APPROVE_HISTORY')}
          >
            <ApproveHistoryPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="history/:id"
        element={
          <GuardedPageRoute pageName="ประวัติการแก้ไขบัญชีผู้ใช้">
            <UserHistoryPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
